import { defineComponent, computed, toRef, Ref } from 'vue';
import { HoursOfOperationDisplayType, ListingUtilities, Listing } from '@truckdown/locations';

const getComputed = (listing: Ref<Listing>) => {
    const iconName = computed(() => {
        const type = listing.value?.hours?.type;

        switch (type) {
            case HoursOfOperationDisplayType.Open: return 'faCircleCheck';
            case HoursOfOperationDisplayType.Closed: return 'faLock';
            case HoursOfOperationDisplayType.AfterHours: return 'faCircleExclamation';

            default: return '';
        }
    });

    const iconStyle = computed(() => {
        const type = listing.value?.hours?.type;

        switch (type) {
            case HoursOfOperationDisplayType.Open: return 'icon open';
            case HoursOfOperationDisplayType.Closed: return 'icon closed';
            case HoursOfOperationDisplayType.AfterHours: return 'icon afterhours';

            default: return '';
        }
    });

    const statusMessage = computed(() => {
        const type = listing.value?.hours?.type;
        switch (type) {
            case HoursOfOperationDisplayType.Open: return 'Open';
            case HoursOfOperationDisplayType.Closed: return 'Closed';
            case HoursOfOperationDisplayType.AfterHours:
                let type = ListingUtilities.getAfterHoursStatusType(listing.value);
                return ListingUtilities.getAfterHoursListingStatus(type);
            default: return '';
        }
    });

    const showHours = computed(() => {
        const type = listing.value?.hours?.type;
        return type === HoursOfOperationDisplayType.Open || type === HoursOfOperationDisplayType.Closed || type === HoursOfOperationDisplayType.AfterHours;
    });

    const message = computed(() => {
        return listing.value.hours.message;
    });

    return {
        iconName,
        iconStyle,
        statusMessage,
        showHours,
        message
    }
}

export default defineComponent({
    props: {
        listing: Object
    },
    emits: [],
    setup: function (props, ctx) {
        let listingValue = toRef(props, "listing") as Ref<Listing>;
        var computed = getComputed(listingValue);

        return {
            ...computed
        };
    }
});
